import { render } from "./order-header.vue?vue&type=template&id=3ddebd91&scoped=true&ts=true"
import script from "./order-header.vue?vue&type=script&lang=ts"
export * from "./order-header.vue?vue&type=script&lang=ts"

import "./order-header.vue?vue&type=style&index=0&id=3ddebd91&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ddebd91"]])

export default __exports__